import { format } from 'date-fns'
import removeIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png'
import editIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/changeTag.png'
import DeviceCard from './DeviceCard'
import { Dialog } from 'primereact/dialog'
import Lottie from 'lottie-react'
import { Button } from 'primereact/button'
import { useState } from 'react'
import { deleteLiveViewCamera } from '../../../../Api Methods/Api'
import areYouSure from '../../../../assets/animations/areYouSure.json'
import { useDispatch, useSelector } from 'react-redux'
import LiveViewCameraEditForm from '../Automations/VirutalSources/LiveView/LiveViewCameraEditForm'


const LiveViewCameraCard = ({camera, refreshDevices, apiData, siteUUID, showSuccess}) => {
    const cameraType = camera.type
    const [showConfirm, setShowConfirm] = useState(false)
    const [showEdit, setShowEdit] = useState(false)
    const dispatch = useDispatch();
    const role = useSelector(state => state.auth.role);

    const unlink = async () => {
        
        const responseData = await deleteLiveViewCamera(apiData, camera.id, dispatch)
        if (responseData) {
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices();
        }
    }
    
    return (
        <>
         <Dialog
            header="Are you sure?"
            visible={showConfirm}
            style={{ width: "40vw" }}
            onHide={() => setShowConfirm(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={areYouSure}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this live view camera?`}</h3>
                <br />
                <Button label="No cancel" icon="pi pi-times" severity="secondary" onClick={() => setShowConfirm(false)} />
                <br />
                <Button label="Yes, unlink" icon="pi pi-check" severity="danger" onClick={() => unlink()} />

            </div>
        </Dialog>

        <Dialog
            header="Edit"
            visible={showEdit}
            style={{ width: "40vw" }}
            onHide={() => setShowEdit(false)}
        >
            <LiveViewCameraEditForm
                camera={camera}
                apiData={apiData}
                siteUUID={siteUUID}
                onClose={() => setShowEdit(false)}
                refreshDevices={refreshDevices}
            />
        </Dialog>

        <DeviceCard
            header={`Live view camera`}
            subHeader={camera.name}
            meta={[camera.type, camera.rtspURL]}
            rightContent={
            <>
            
                {(role === "admin" || role === "TechSupport") && <img src={removeIcon} style={{width:"25px", cursor:"pointer"}} onClick={() => setShowConfirm(true)} />}
                {(role === "admin" || role === "TechSupport") && <img src={editIcon} style={{width:"25px", cursor:"pointer"}} onClick={() => setShowEdit(true)} />}
       
              
            </>
            }
            footer={
                camera.addedBy &&
                `Added by ${camera.addedBy} on ${format(
                    new Date(camera.dateAdded),
                    "MMM do, yyyy"
                )}`
            }
        />
        </>
    );
}

export default LiveViewCameraCard;